<template>
  <div class="ecosystem">
    <div class="content-center">
      <img class="module-left" src="@/assets/img/service-provider/Ecosystem/ecosystem.png">
      <div class="module-right">
        <div class="content-title">易隆创・服务生态是连接平台 2000 + 云企业与服务商的高效协同生态</div>
        <div class="content-text">平台注册的云企业，既可以作为需求方发起各类工单无论是<span class="text-bold">单点即时需求</span>，还是对接<span class="text-primary">易隆创・项目管理</span>的<span class="text-bold">整体项目外包</span>，以及提供驻场支持的<span class="text-bold">异地服务</span>。</div>
        <div class="content-text">云企业也能申请成为服务商，依托平台获取商机通过按标签与区域定位体系，服务商可精准承接全国范围内的工单，实现就近响应、高效服务。</div>
        <div class="content-text">全流程数字化管控既保障云企业以更优成本获得优质服务，也让服务商轻松拓宽业务边界，在生态协同中实现资源高效流转与价值共赢。</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.ecosystem {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .module-left {
      width: 514px;
      height: 300px;
    }

    .module-right {
      width: 624px;
      text-align: justify;

      .content-title {
        font-weight: bold;
        font-size: 18px;
      }
      .content-text {
        margin-top: 38px;
        line-height: 26px;
        .text-bold {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
